module.exports = __webpack_public_path__ + "img/ico_sp.b234756f.png";